export const starPrincing = (dataStar) => {
  if (!dataStar) return;
  let valueString = dataStar?.getStarPricing[0].value_string;
  valueString = valueString.replace(/'/g, '"');
  valueString = JSON.parse(valueString);
  let valueNumber = dataStar?.getStarPricing[0].value_number
  let data = {"valueString": valueString, "valueNumber": valueNumber};
  return data;
};
